import { defineMessages } from 'react-intl';

const messages = defineMessages({
  brandLabel: {
    defaultMessage: 'Brand',
    id: '3YYxxL',
    description: 'Order Details > Customer Communication > Seller Brand Label',
  },
  noBrandText: {
    defaultMessage: 'None',
    id: 'rGjIrK',
    description: 'Order Details > Customer Communication > Seller Brand None Text',
  },
  packingSlipLabel: {
    defaultMessage: 'Packing Slip',
    description: 'orderDetails.packingSlip',
    id: 'AdM5bC',
  },
  packingSlipDefault: {
    defaultMessage: 'Select a Packing Slip',
    description: 'orderDetails.selectAPackingSlip',
    id: 'dlEV/P',
  },
  shipmentNotificationLabel: {
    defaultMessage: 'Shipment Notification',
    description: 'orderDetails.shipmentNotification',
    id: '5ZbPeZ',
  },
  shipmentNotificationDefault: {
    defaultMessage: 'Select a Shipment Notification',
    description: 'orderDetails.selectAShipmentNotification',
    id: 'lnl49V',
  },
  dontSendShipmentNotification: {
    description: 'dontSendShipmentNotification.dontSendShipmentNotificationTemplate',
    defaultMessage: "Don't Send Email (Default)",
    id: 'DkBlyL',
  },
  deliveryNotificationLabel: {
    defaultMessage: 'Delivery Notification',
    description: 'orderDetails.deliveryNotification',
    id: 'WtjW5z',
  },
  deliveryNotificationDefault: {
    defaultMessage: 'Select a Delivery Notification',
    description: 'orderDetails.selectADeliveryNotification',
    id: 'h/j189',
  },
  dontSendDeliveryNotification: {
    description: 'dontSendDeliveryNotification.dontSendDeliveryNotificationTemplate',
    defaultMessage: "Don't Send Email (Default)",
    id: 'kAs8fH',
  },
});

export default messages;
